import { ContextModalProps } from '@mantine/modals';
import { IconArrowsLeftRight, IconCash, IconReceipt } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ModalOptionButton } from 'src/Components/Buttons/ModalOptionButton';
import useNavigateKeepingSearch from 'src/Hooks/Shared/useNavigateKeepingSearch';

import styles from './OperationTypeModal.module.scss';

interface OperationTypeModalProps {
  assetId: string;
}

const OperationTypeModal = ({
  context,
  id,
  innerProps,
}: ContextModalProps<OperationTypeModalProps>) => {
  const { t } = useTranslation();
  const navigate = useNavigateKeepingSearch();

  const handleTransfer = () => {
    context.closeModal(id);
    navigate(`/asset/${innerProps.assetId}/expenses/new-transfer`);
  };

  const handleIncome = () => {
    context.closeModal(id);
    navigate(`/asset/${innerProps.assetId}/expenses/new`, { state: { isIncome: true } });
  };

  const handleExpense = () => {
    context.closeModal(id);
    navigate(`/asset/${innerProps.assetId}/expenses/new`, { state: { isIncome: false } });
  };

  return (
    <div className={styles.container}>
      <ModalOptionButton
        icon={<IconReceipt size={32} />}
        title={t('operationType.expense.title', 'Déclarer une dépense')}
        description={t(
          'operationType.expense.description',
          "Quelqu'un a payé quelque chose (ex: courses, électricien, travaux...)"
        )}
        onClick={handleExpense}
      />
      <ModalOptionButton
        icon={<IconArrowsLeftRight size={32} />}
        title={t('operationType.transfer.title', 'Enregistrer un remboursement')}
        description={t(
          'operationType.transfer.description',
          'Une personne a remboursé une autre personne ou un compte commun'
        )}
        onClick={handleTransfer}
      />
      <ModalOptionButton
        icon={<IconCash size={32} />}
        title={t('operationType.income.title', 'Déclarer une recette')}
        description={t(
          'operationType.income.description',
          "Quelqu'un a reçu une somme d'argent (ex: loyer, remboursement assurance...)"
        )}
        onClick={handleIncome}
      />
    </div>
  );
};

export default OperationTypeModal;
